import appGlobalScript from 'C:/Users/z004v71j/Desktop/quickTest/stencil-git/stenciljs-poc-app/src/global/app.ts';
export const globalScripts = appGlobalScript;
